import { createAsyncThunk } from '@reduxjs/toolkit';
import taskAPI from '@infrastructure/task-api';
import { getErrorPayload } from '@application/helpers/api-helper';
export const createTaskAsync = createAsyncThunk('task/create', async (task, { rejectWithValue }) => {
    try {
        const response = await taskAPI.createTask(task);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateTaskAsync = createAsyncThunk('task/update', async (task, { rejectWithValue }) => {
    try {
        const response = await taskAPI.updateTask(task);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllTasksAsync = createAsyncThunk('task/getAll', async (_, { rejectWithValue }) => {
    try {
        const response = await taskAPI.getAllTasks();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllTaskAssignedToUserAsync = createAsyncThunk('task/getAllTaskAssignedToUser', async (_, { rejectWithValue }) => {
    try {
        const response = await taskAPI.getAllTaskAssignedToUser();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getTasksGroupedByStatusAsync = createAsyncThunk('task/getTasksGroupByStatus', async (query, { rejectWithValue }) => {
    try {
        const response = await taskAPI.getTasksGroupedByStatus(query);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getTaskByIdAsync = createAsyncThunk('task/getTaskById', async (taskId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await taskAPI.getTaskById(taskId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteTaskAsync = createAsyncThunk('task/delete', async (taskId, { rejectWithValue }) => {
    try {
        const response = await taskAPI.deleteTask(taskId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getTasksByEventIdGroupedByStatusAsync = createAsyncThunk('tasks/grouped-by-status/event', async ({ eventId, query }, { rejectWithValue }) => {
    try {
        const response = await taskAPI.getTasksByEventIdGroupedByStatus(eventId, query);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllActivityTasksAsync = createAsyncThunk('task/getAllActivityTasks', async (personId, { rejectWithValue }) => {
    try {
        const response = await taskAPI.getAllActivityTasks(personId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
